export default [{
    path: '/dashboard',
    name: 'dashboard',
    meta: {
        requiresAuth: true
    },
    children: [{
        path: '/invoice/list',
        name: 'InvoiceList',
        components:{
            
            default: resolve => require(['./list.vue'], resolve)
        }
    },{
        path: '/invoice/update',
        name: 'InvoiceUpdate',
        components:{
            
            default: resolve => require(['./update.vue'], resolve)
        }
    }]
}]



// WEBPACK FOOTER //
// ./src/views/invoice/router.js